// @ vendor
const Immutable = require('immutable');
// @ constants
const {
    MORTGAGE_REQUEST_FETCH_SIMPLE_NOTE_REQUEST_WIZARD_VALIDATE_STEP
} = require('constants/actionTypes');

const setInitialState = () =>{
    return Immutable.Map().merge({
        valid: false
    });
};

const validateStep = (step)=> {
    return step.merge({
        valid: true
    });
};

const mortgageRequestSimpleNoteRequestStep1 = (state = setInitialState(), action) => {
    switch (action.type) {
        case MORTGAGE_REQUEST_FETCH_SIMPLE_NOTE_REQUEST_WIZARD_VALIDATE_STEP:
            return validateStep(state);
    }

    return state;
};

module.exports = mortgageRequestSimpleNoteRequestStep1;
